import { useRoute } from 'vue-router';
import { defineComponent } from "vue";
import VueCookie from 'vue-cookie'
import { useToast } from "vue-toastification";

/* eslint-disable */
export default defineComponent({
   name: "navbar",
   computed: { 
    route: () => useRoute() 
   },
   setup() {
      const toast = useToast();
      return { toast };
   },
   mounted() {
        this.customerName = VueCookie.get("name");
        this.customerEmail = VueCookie.get("email");
        this.url = process.env.BASE_URL;
   },
   data() {
      return {
         customerName: '',
         customerEmail: '',
         url:''
      };
   },
   methods: {
      logout() {
         VueCookie.delete('customer_token');
         this.$router.push('/login');
         this.toast.success('Logged Out');
     },
   },
});
